<template>
  <div
    ref="modalRef"
    class="modal"
    :class="isShown ? 'modal_active' : ''"
    @click="check"
  >
    <div
      class="modal_in"
    >
      <div
        v-if="closeButtonOutside"
        class="closeButtonOutside"
      >
        <AppButton
          variant="secondary"
          @click="$emit('close')"
        >
          <Icon
            :icon="require(`@/assets/icons/white_24_cross.svg`)"
          />
        </AppButton>
      </div>

      <div
        v-if="hasTitleClose"
        class="modal_top"
      >
        <button
          v-if="hasTitleClose"
          class="close_modal"
          @click="$emit('close')"
        >
          <img
            src="@/assets/images/modal_close.svg"
            alt=""
          />
        </button>
      </div>

      <slot />
    </div>
  </div>
</template>

<script setup>
import {ref, watch} from 'vue'
import AppButton from '@/components/UI/AppButton.vue'
import Icon from '@/components/UI/Icon.vue'
import {useModalScrollingFix} from '@/hooks/useModalScrollingFix'

const modalScrollingFix = useModalScrollingFix()

const modalRef = ref(null)

const emit = defineEmits(['close'])

const props = defineProps({
  closeOnClickAway: {
    type: Boolean,
    default: true,
  },
  isShown: {
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  hasTitleClose: {
    type: Boolean,
    default: true,
  },
  closeButtonOutside: {
    type: Boolean,
    default: false,
  }
})

watch(() => props.isShown, (value) => {
  if(value) {
    modalScrollingFix.open()
  } else {
    modalScrollingFix.close()
  }
})

function check(event) {
  if (event.target === modalRef.value && props.closeOnClickAway) {
    emit('close')
  }
}

</script>

<style lang="scss" scoped>
.modal {
  // Вместо width: 0 / height: 0 используем pointer-events,
  // чтобы не ломать анимацию opacity и backdrop-filter
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(13px);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: -1;
  opacity: 0;
  pointer-events: none;


  transition: opacity .4s ease, backdrop-filter .4s ease, z-index .4s;

  .modal_in {
    max-width: 480px;
    width: calc(100% - 70px);
    border-radius: 16px;
    background: var(--card-secondary-background);
    padding: 16px;
    position: relative;

    transform: scale(0.9);
    transition: transform .4s cubic-bezier(0.34, 1.56, 0.64, 1);

    background-image: radial-gradient(
      ellipse 205px 205px at center 40%,

      rgba(207, 46, 46, 0.6) 0%,
      rgba(207, 46, 46, 0) 100%
    );

    .modal_top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: right;
      color: var(--text-primary-color);
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0;
      margin-bottom: 20px;
    }
  }
}

.modal_active {
  opacity: 1;
  z-index: 1001;
  pointer-events: auto;

  .modal_in {
    transform: scale(1);
  }
}

.closeButtonOutside {
  position: absolute;
  right: 16px;
  top: 16px;
}
</style>
